// 公共模块
export const G                                   = {
	blog                                         : '我的部落格後端',
}

export const lang                                = {
	auto                                         : '自動檢測',
	zh                                           : '中文簡體',
	tw                                           : '中文繁體',
	en                                           : '英文',
	ja                                           : '日語',
}



// WEBPACK FOOTER //
// ./src/assets/lang/tw.js